// extracted by mini-css-extract-plugin
module.exports = {"FormContainer":"Form_FormContainer__2IIe3"};